<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" v-bind:class="className">
            <div class="modal-overlay" @click="back()"></div>
            <div class="modal">
                <article v-if="resource">

                    <header>
                        <figure>
                          <img :src="$iconFolder + 'discount.svg'"/>
                        </figure>
                        <div>
                            <span class="breadcrumb">
                                Voucher <i class="icon icon-icon_arrow-right"></i> Edit
                            </span>
                            <h1>{{ resource.name ? resource.name : 'Nouveau' }}</h1>
                        </div>
                        <div class="spacer"></div>
                        <div class="buttons">
                            <button @click="back()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                            <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                        </div>
                        <notice-published v-model="resource" label-published="Cette promotion est active." label-unpublished="Cette promotion est inactive." :dates="true"></notice-published>
                    </header>

                    <main>

                         <languages :translations="resource.translations" :localesLoaded="localesLoaded" :locales="locales" v-model="locale"></languages>

                        <tabs :options="{ useUrlFragment: false }">
                            <tab name="Information">

                              <fieldset>
                                <h3>Détail de la promotion</h3>
                                <p class="headline"></p>

                                <form-scopes label='Scopes' v-model="resource"></form-scopes>

                                <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                  <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                      <form-text
                                          :translate-key="'name'" :translations="resource.translations"
                                          :lang="client.id" :label="'Nom'" v-model="resource.translations[client.id].name" :required="true"></form-text>
                                  </div>
                                </div>

                                <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                  <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                      <form-text :translate-key="'description'" :translations="resource.translations" :lang="client.id" :label="'Description'" v-model="resource.translations[client.id].description" :required="true"></form-text>
                                  </div>
                                </div>

                                <group-line-2>
                                <form-toggle label="Somme" v-model="resource.is_number"></form-toggle>
                                <form-text label="Valeur" v-model="resource.value" :suffix="resource.is_number?$store.state.scope.currency_id:'%'" :required="true"></form-text>
                                </group-line-2>

                                <form-autocomplete label="Produits" multiple="true" v-model="resource.products" :default="resource.products" :service="products"></form-autocomplete>
                                <form-autocomplete label="Categories" multiple="true" v-model="resource.categories" :default="resource.categories" :service="categories"></form-autocomplete>
                                <form-autocomplete label="Marques" multiple="true" v-model="resource.brands" :default="resource.categories" :service="brands"></form-autocomplete>

                                <form-toggle label="Livraison gratuite" v-model="resource.has_free_delivery"></form-toggle>

                              </fieldset>

                            </tab>
                            <tab name="Conditions" class="vouchers-conditions">

                              <fieldset>
                                <h3>Conditions d'application de la promotion</h3>
                                <p class="headline"></p>

                                <div v-for="(group, i) in conditions" v-if="conditions">
                                    <div class="group">
                                        <div v-for="(condition, x) in group">
                                            <table>
                                                <tr>
                                                    <td><select v-model="condition.type">
                                                        <option value="country">country</option>
                                                        <option value="total">total</option>
                                                        <option value="subtotal">subtotal</option>
                                                        <option value="totalItems">totalItems</option>
                                                    </select></td>
                                                    <td><select v-model="condition.operator">
                                                        <option value="egal">=</option>
                                                        <option value="greater_than">&gt;</option>
                                                        <option value="egal_greater_than">&gt;=</option>
                                                        <option value="less_than">&lt;</option>
                                                        <option value="egal_less_than">&lt;=</option>
                                                        <option value="not_egal">!=</option>
                                                        <option value="in">in</option>
                                                    </select></td>
                                                    <td><input type="text" v-model="condition.value"/></td>
                                                    <td><button @click="removeCondition(i, x)" class="bt-remove"><span class="icon icon-icon_close"></span></button></td>
                                                </tr>
                                            </table>
                                        </div>
                                        <button @click="renoveGroup(i)" class="btn">Remove group</button>
                                        <button @click="addToGroup(i)" class="btn">Add new condition</button>
                                        <span>ou</span>
                                    </div>
                                </div>
                                <button @click="addGroup()" class="btn">Add new group</button>

                              </fieldset>

                            </tab>
                        </tabs>

                    </main>
                </article>

            </div>
        </div>
    </transition>
</template>
<script>

    import DiscountService from './DiscountService.js';
    import ProductService from './../product/ProductService.js';
    import CategoryService from './../category/CategoryService.js';
    import BrandService from './../brand/BrandService.js';
    import Edit from '../../../layouts/Edit.vue';

    export default {
        extends: Edit,
        data () {
            return {
                products: null,
                categories: null,
                brands: null,
                conditions: [],
                scopes: [{id:'subtotal', name: 'Subtotal'},{id:'product', name: 'Products'}],
                somme: ""
            }
        },
        mounted: function(){

            this.products = ProductService;
            this.categories = CategoryService;
            this.brands = BrandService;

            var countries = {}
            for (let item of this.$store.state.countries) {
                countries[this.resource.id] = item
            }

        },
        methods:{
            resourceLoaded: function(){
                this.setTranslations(['name','description']);
                this.conditions = this.resource.conditions||[];

                /* CONVERT DATES TO LOCAL TIMZONE */
                this.resource.start_at = this.$helpers.utcToLocal(this.resource.start_at, this.$store.state.scope.timezone) ? this.$helpers.utcToLocal(this.resource.start_at, this.$store.state.scope.timezone).format() : null;
                this.resource.end_at = this.$helpers.utcToLocal(this.resource.end_at, this.$store.state.scope.timezone) ? this.$helpers.utcToLocal(this.resource.end_at, this.$store.state.scope.timezone).format() : null;
                /*****/

                this.initialize()
            },
            getResource: function(){
                return DiscountService
            },
            beforeUpdate: function(Resource){
              console.log("RESOURCE", Resource)

              Resource.products = Resource.products.map(p => p.id);
              Resource.categories = Resource.categories.map(p => p.id);
              Resource.brands = Resource.brands.map(p => p.id);

              console.log("RESOURCE", Resource)

                this.updateVars();
                return true;
            },
            // CONDITIONS
            updateVars: function(){
                let tmp_conditions = [];
                for (var i=0 ; i<this.conditions.length ; i++) {
                    var tmp_sub_conditions = [];
                    for (var x=0 ; x<this.conditions[i].length ; x++) {
                        var obj = {};
                        obj.type = this.conditions[i][x].type;
                        obj.operator = this.conditions[i][x].operator;
                        obj.value = this.conditions[i][x].value;
                        tmp_sub_conditions.push(obj);
                    }
                    tmp_conditions.push(tmp_sub_conditions);
                }
                this.conditions = tmp_conditions;
                this.resource.conditions = this.conditions;
                console.log(this.conditions);
            },
            addGroup: function(){
                this.conditions.push([]);
                this.updateVars();
            },
            addToGroup: function(index){
                this.conditions[index].push({
                    type: "country",
                    operator: "egal",
                    value: ""
                });
                this.updateVars();
            },
            renoveGroup: function(index){
                this.conditions.splice(index,1);
                this.updateVars();
            },
            removeCondition: function(index, index2){
                this.conditions[index].splice(index2,1);
                this.updateVars();
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/shop/discount/Edit.vue